export const CHATBOT_TYPE = Object.freeze({
    typeGreeting: 'chatbot-greeting',
    typeSolution: 'chatbot-solution',
    typeClosing: 'chatbot-closing',
    typeError: 'chatbot-error',
    typeCreateTicket: 'chatbot-create-ticket',
    typeTimeout: 'chatbot-timeout',
    typeQuestion: 'chatbot-question',
})